import { render, staticRenderFns } from "./AdminAuthorization.vue?vue&type=template&id=69b6eea5"
import script from "./AdminAuthorization.vue?vue&type=script&lang=js"
export * from "./AdminAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports